/**
 * Якоря для продукт-туров usertour (атрибут data-tour).
 *
 * Значения здесь должны совпадать с селекторами в определениях flow в usertour
 * (usertour.rocketdata.io). Не меняйте значения без синхронной правки соответствующего
 * тура — иначе шаг тура перестанет находить элемент.
 */
export enum DataTourAnchorEnum {
    AddQueryBrand = 'add-query-brand',
    AddQueryFrequency = 'add-query-frequency',
    AddQueryMap = 'add-query-map',
    AddQueryName = 'add-query-name',
    AddQueryPointDistance = 'add-query-point-distance',
    AddQuerySearchPhrases = 'add-query-search-phrases',
    AddQueryServices = 'add-query-services',
    AddQuerySquareSize = 'add-query-square-size',
    AddQuerySubmit = 'add-query-submit',
    CollectionResultsCompanyInfo = 'collection-results-company-info',
    CollectionResultsDateNavigation = 'collection-results-date-navigation',
    CollectionResultsKeywordsTabs = 'collection-results-keywords-tabs',
    CollectionResultsMapGrid = 'collection-results-map-grid',
    CollectionResultsServiceSelector = 'collection-results-service-selector',
    CompanyFormAddress = 'company-form-address',
    CompanyFormAttributes = 'company-form-attributes',
    CompanyFormBrand = 'company-form-brand',
    CompanyFormCategories = 'company-form-categories',
    CompanyFormCategoriesCatalogs = 'company-form-categories-catalogs',
    CompanyFormContactInfo = 'company-form-contact-info',
    CompanyFormDescription = 'company-form-description',
    CompanyFormGallery = 'company-form-gallery',
    CompanyFormLegal = 'company-form-legal',
    CompanyFormLinks = 'company-form-links',
    CompanyFormLinksMain = 'company-form-links-main',
    CompanyFormLogo = 'company-form-logo',
    CompanyFormNamesCatalogs = 'company-form-names-catalogs',
    CompanyFormSave = 'company-form-save',
    CompanyFormTemporaryWorkingTime = 'company-form-temporary-working-time',
    CompanyFormWorkingTime = 'company-form-working-time',
    DuplicatesActionDelete = 'duplicates-action-delete',
    DuplicatesActionNotDuplicate = 'duplicates-action-not-duplicate',
    DuplicatesColCatalog = 'duplicates-col-catalog',
    DuplicatesColDate = 'duplicates-col-date',
    DuplicatesColFoundLocation = 'duplicates-col-found-location',
    DuplicatesColMainLocation = 'duplicates-col-main-location',
    DuplicatesColStatus = 'duplicates-col-status',
    DuplicatesFilters = 'duplicates-filters',
    DuplicatesLocationLink = 'duplicates-location-link',
    DuplicatesSettingsButton = 'duplicates-settings-button',
    DuplicatesStatistics = 'duplicates-statistics',
    DuplicatesStatusFilters = 'duplicates-status-filters',
    DuplicatesTable = 'duplicates-table',
    KeysAnalyticsCompletedSearchesCell = 'keys-analytics-completed-searches-cell',
    KeysAnalyticsDownloadButton = 'keys-analytics-download-btn',
    KeysAnalyticsGridSizeCell = 'keys-analytics-grid-size-cell',
    KeysAnalyticsTableCard = 'keys-analytics-table-card',
    LeaderboardKeysCell = 'leaderboard-keys-cell',
    LeaderboardPositionCell = 'leaderboard-position-cell',
    LeaderboardTable = 'leaderboard-table',
    OnboardingStorlokatorCardPageElements = 'onboarding-storlokator-card-page-elements',
    OnboardingStorlokatorCardSeo = 'onboarding-storlokator-card-seo',
    OnboardingStorlokatorCompanies = 'onboarding-storlokator-companies',
    OnboardingStorlokatorCreateButton = 'onboarding-storlokator-create-button',
    OnboardingStorlokatorMapboxKey = 'onboarding-storlokator-mapbox-key',
    OnboardingStorlokatorName = 'onboarding-storlokator-name',
    OnboardingStorlokatorSave = 'onboarding-storlokator-save',
    OnboardingStorlokatorScriptSnippet = 'onboarding-storlokator-script-snippet',
    OnboardingStorlokatorSettingsBasic = 'onboarding-storlokator-settings-basic',
    OnboardingStorlokatorSettingsCardList = 'onboarding-storlokator-settings-card-list',
    OnboardingStorlokatorSettingsColors = 'onboarding-storlokator-settings-colors',
    OnboardingStorlokatorSettingsFilter = 'onboarding-storlokator-settings-filter',
    OnboardingStorlokatorSettingsSeo = 'onboarding-storlokator-settings-seo',
    OnboardingStorlokatorSubmit = 'onboarding-storlokator-submit',
    OnboardingStorlokatorWebsite = 'onboarding-storlokator-website',
    PositionTrackerChart = 'position-tracker-chart',
    PositionTrackerFilterButton = 'position-tracker-filter-button',
    PositionTrackerNavTabs = 'position-tracker-nav-tabs',
    PositionTrackerQueryRow = 'position-tracker-query-row',
    PositionTrackerQueryTable = 'position-tracker-query-table',
    PositionTrackerResultsDateCell = 'position-tracker-results-date-cell',
    PositionTrackerResultsPositionCell = 'position-tracker-results-position-cell',
    PositionTrackerResultsTable = 'position-tracker-results-table',
    PositionTrackerServiceCheckbox = 'position-tracker-service-checkbox',
    QueriesCreateButton = 'queries-create-button',
    QueriesExpandIconCell = 'queries-expand-icon-cell',
    QueriesRowActions = 'queries-row-actions',
    QueriesRowSettings = 'queries-row-settings',
    QueriesRulesTable = 'queries-rules-table',
    SourcesAccountsButton = 'sources-accounts-button',
    SourcesFilter = 'sources-filter',
    SourcesLink = 'sources-link',
    SourcesRating = 'sources-rating',
    SourcesSourceCol = 'sources-source-col',
    SourcesStatus = 'sources-status',
    SourcesStatusFilter = 'sources-status-filter',
    UsersAddButton = 'users-add-button',
    UsersAvailableCounter = 'users-available-counter',
    ValidationBrandsTable = 'validation-brands-table',
    ValidationConnectedFeedsButton = 'validation-connected-feeds-button',
    ValidationFeedTabs = 'validation-feed-tabs',
    ValidationFormatSelect = 'validation-format-select',
    ValidationSubmitButton = 'validation-submit-button',
    ValidationTemplateList = 'validation-template-list',
}
